export default "__VITE_ASSET__SfutAoLx__"